export enum PlasticDishesLabels {
  type = "type",
  dimensions = "dimensions",
  color = "color",
  print = "print",
}
